'use strict'

const React = require('react')
const EngineHelper = require('../engines/engineHelper.js')
const DateHelper = require('../../../../../_plugins/lib/dateHelper')
const propTypes = require('prop-types');
const classNames = require('classnames')
const { oneOfType, string, bool, func, number } = propTypes
const createReactClass = require('create-react-class');

const TimeSelect = createReactClass({
  mixins: [EngineHelper],

  propTypes: {
    startingTime: oneOfType([string, number]),
    activeTime: oneOfType([string, number]),
    name: string,
    fullWidth: bool,
    hourSplit: number,
    startTime: number,
    endTime: number,
    pagename: string,
    onSelect: func,
    onError: string,
    id: string,
    betweenTimes: bool,
    loopOver: bool,
    showMidnight: bool,
    hiddenLabel: bool
  },

  getDefaultProps () {
    return {
      startingTime: '1200',
      activeTime: '1200',
      startTime: 15,
      endTime: 2400,
      fullWidth: false,
      hourSplit: 0.5,
      betweenTimes: false,
      loopOver: false,
      showMidnight: false,
      hiddenLabel: false
    }
  },

  getInitialState () {
    const { activeTime } = this.props
    return { activeTime }
  },

  shouldComponentUpdate (nextProps, nextState) {
    if (this.checkUpdated(nextProps.startingTime, this.props.startingTime)) return true
    if (this.checkUpdated(nextProps.startTime, this.props.startTime)) return true
    if (this.checkUpdated(nextProps.endTime, this.props.endTime)) return true
    if (this.checkUpdated(nextProps.fullWidth, this.props.fullWidth)) return true
    if (this.checkUpdated(nextProps.hourSplit, this.props.hourSplit)) return true
    if (this.checkUpdated(nextProps.loopOver, this.props.loopOver)) return true
    if (this.checkUpdated(nextProps.activeTime, this.props.activeTime)) return true
    if (this.checkUpdated(nextProps.showMidnight, this.props.showMidnight)) return true
    if (this.checkUpdated(nextProps.hiddenLabel, this.props.hiddenLabel)) return true
    if (this.checkUpdated(nextState.activeTime, this.state.activeTime)) return true
    return false
  },

  componentDidUpdate (prevProps) {
    if (this.checkUpdated(this.props.activeTime, this.state.activeTime)) {
      this.handleChange({ target: { value: this.props.activeTime } })
    }
  },

  loopOver (arr, hourLoops) {
    const { startingTime } = this.props
    let startArray = []
    const endArray = []
    arr.map(i => {
      if ((i * 100) < Number(startingTime)) return endArray.push(i)
      startArray.push(i)
    })
    return startArray.concat(endArray)
  },

  makeOptions () {
    const { hourSplit, startTime, endTime, betweenTimes, loopOver, showMidnight } = this.props
    const hourLoops = (24 / hourSplit) / 24
    let arr = Array.apply(null, { length: 24 }).map(Number.call, Number)
    if (loopOver) arr = this.loopOver(arr, hourLoops)
    let iteration, padVal
    return arr.map(i => {
      const segmentArray = Array.apply(null, { length: hourLoops }).map(Number.call, Number)
      iteration = 0
      const incrementIteration = () => {
        iteration = iteration + 60 / hourLoops
      }
      return segmentArray.map(() => {
        if ((i && showMidnight) || !showMidnight) {
          if (((i * 100) + iteration) < startTime) return incrementIteration()
        }
        if (((i * 100) + iteration) > endTime) return incrementIteration()
        padVal = (iteration === 0 && i === 0) ? '0000' : DateHelper.pad((i * 100) + iteration, 4)
        incrementIteration()
        let returnText = padVal.slice(0, 2) + ':' + padVal.slice(-2)
        if (betweenTimes) {
          const nextPadVal = (iteration === 0 && i === 0) ? '0000' : DateHelper.pad((i * 100) + iteration, 4)
          let mins = Number(nextPadVal.slice(-2)) >= 60 ? '60' : nextPadVal.slice(-2)
          mins = Number(mins) - 1
          returnText += ' - ' + nextPadVal.slice(0, 2) + ':' + mins
        }
        return (<option key={padVal} value={padVal}>{ returnText }</option>)
      }).filter(i => {
        return i
      })
    }).filter(i => {
      return i.length
    })
  },

  handleChange (e) {
    const { value } = e.target
    const { name, onSelect } = this.props
    if (onSelect) onSelect(name, value)
    this.setState({ activeTime: value })
  },

  render () {
    let { name, onError, startTime, openStart, id, hiddenLabel, onSelect = false, fullWidth } = this.props
    let { activeTime } = this.state
    let times = this.makeOptions()
    if (+activeTime < openStart) activeTime = startTime
    if (activeTime.length < 4) activeTime = DateHelper.pad(activeTime, 4)
    if (!times.length && onError) {
      return (
        <span dangerouslySetInnerHTML={{ __html: onError }} />
      )
    } else if (!times.length) {
      times = (<option value=''>No options</option>)
    }
    const propParams = {
      onChange: this.handleChange,
      id,
      name,
      className: 'form-control',
      'data-track-name': name
    }
    propParams[onSelect ? 'value' : 'defaultValue'] = activeTime
    return (
      <select {...propParams}>{times}</select>
    )
  }
})

module.exports = TimeSelect





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/engines/times-dropdown-flight.jsx